import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Select, Space, Spin } from 'antd';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { useBatchConfig } from '../../hooks/useBatchConfig';
import { useBatchTransactionStore } from '../../stores/batch-transaction-store';
import BatchConfigForm from '../BatchConfigForm';
import type { BatchConfigDTO } from '../../types';

const { Option } = Select;

interface Props {
  onNext: () => void;
}

const Step1SelectConfig: React.FC<Props> = ({ onNext }) => {
  const { configs, configsLoading, loadConfigs } = useBatchConfig();
  const { selectedConfig, setSelectedConfig } = useBatchTransactionStore();
  const [formOpen, setFormOpen] = useState(false);

  useEffect(() => {
    loadConfigs();
  }, [loadConfigs]);

  const handleSelect = (id: number) => {
    const found = configs.find((c) => c.id === id) ?? null;
    setSelectedConfig(found);
  };

  const handleConfigSaved = (config: BatchConfigDTO) => {
    setSelectedConfig(config);
    loadConfigs();
  };

  return (
    <div className="max-w-lg mx-auto pt-4 space-y-4">
      <Card title="Select Batch Configuration">
        <div className="space-y-4">
          <div className="flex gap-2">
            <Select
              value={selectedConfig?.id ?? undefined}
              onChange={handleSelect}
              placeholder="Choose a configuration…"
              loading={configsLoading}
              className="flex-1"
              showSearch
              optionFilterProp="children"
            >
              {configs.map((c) => (
                <Option key={c.id} value={c.id!}>
                  <div>
                    <div className="font-medium">{c.name}</div>
                    <div className="text-xs text-gray-500">{c.code}</div>
                  </div>
                </Option>
              ))}
            </Select>
            <Button icon={<ReloadOutlined />} onClick={loadConfigs} loading={configsLoading} />
            <Button icon={<PlusOutlined />} onClick={() => setFormOpen(true)}>
              New
            </Button>
          </div>

          {selectedConfig && (
            <Alert
              type="success"
              showIcon
              message={`Selected: ${selectedConfig.name}`}
              description={selectedConfig.description}
            />
          )}

          <div className="flex justify-end">
            <Button
              type="primary"
              disabled={!selectedConfig}
              onClick={onNext}
            >
              Next: Upload File
            </Button>
          </div>
        </div>
      </Card>

      <BatchConfigForm
        open={formOpen}
        onClose={() => setFormOpen(false)}
        onSaved={handleConfigSaved}
      />
    </div>
  );
};

export default Step1SelectConfig;
